module.exports = __webpack_public_path__ + "static/img/baojingqueren.df21b06.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/baojingqueren.png
// module id = M0Z6
// module chunks = 24